import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=5687a1a2&scoped=true&"
import script from "./TestReport.vue?vue&type=script&lang=js&"
export * from "./TestReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687a1a2",
  null
  
)

export default component.exports